module.exports = __webpack_public_path__ + "img/ticket_text1.0d0dd052.svg";